import React from 'react';

export default function ErrorToastContainer({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return <>{children}</>;
}
